(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["address-autocomplete"] && !Shopify.designMode) return;
  try {
    class AddressAutocomplete extends HTMLElement {
    connectedCallback() {
      // this.apiKey = 'AIzaSyAeNKKnxB9YoUu5z_qgE8q8eI2wfMj__5c';
      this.apiKey = 'AIzaSyCdnAtEUtFja4eHMVCLniFscuZxJjURwQA';
      // this.apiKey = 'AIzaSyCkpp0B_1YDbuwl3pZBYO0SPfd0HYwjebI';
      this.placeholder = this.dataset.placeholder || 'Αναζητήστε τη διεύθυνσή σας...';
      this.inputName = this.dataset.inputName || 'address';
      this.country = this.dataset.country || 'gr';
      this.language = this.dataset.language || 'el';
      this.clearLabel = this.dataset.clearLabel || 'Clear';
      this.debounce = null;

      this.sessionToken = null;

      this.render();
      this.bindEvents();
    }

    render() {
      this.innerHTML = `
        <div class="address-autocomplete__wrapper">
          <input
            type="text"
            name="${this.inputName}"
            class="address-autocomplete__input"
            placeholder="${this.placeholder}"
            aria-label="${this.placeholder}"
            autocomplete="off"
            role="combobox"
            aria-expanded="false"
            aria-autocomplete="list"
          >
          <button
            type="button"
            class="address-autocomplete__clear"
            aria-label="${this.clearLabel}"
            hidden
          >
            <svg width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M17 1L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 1L17 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <ul class="address-autocomplete__dropdown" role="listbox" hidden></ul>
          <p class="address-autocomplete__error" hidden>
            Παρακαλώ επιλέξτε διεύθυνση από τη λίστα προτάσεων.
          </p>
        </div>
      `;

      this.input = this.querySelector('input');
      this.clearBtn = this.querySelector('.address-autocomplete__clear');
      this.dropdown = this.querySelector('ul');
      this.error = this.querySelector('p');

      const self = this;
      this.resizeObserver = new ResizeObserver(function onDropdownResize() {
        if (!self.dropdown.hidden) {
          self.positionDropdown();
        }
      });
      this.resizeObserver.observe(this.dropdown);

      window.addEventListener(
        'scroll',
        function onScroll() {
          if (!self.dropdown.hidden) {
            self.positionDropdown();
          }
        },
        { passive: true }
      );

      window.addEventListener(
        'resize',
        function onWindowResize() {
          if (!self.dropdown.hidden) {
            self.positionDropdown();
          }
        },
        { passive: true }
      );
    }

    updateClearBtn() {
      if (this.clearBtn) {
        this.clearBtn.hidden = !this.input.value;
      }
    }

    bindEvents() {
      const self = this;

      this.input.addEventListener('input', function onInput() {
        self.updateClearBtn();
        clearTimeout(self.debounce);
        self.debounce = setTimeout(function doFetch() {
          self.fetchSuggestions(self.input.value.trim());
        }, 500);
      });

      this.clearBtn.addEventListener('click', function onClear() {
        self.input.value = '';
        self.updateClearBtn();
        self.closeDropdown();
        self.hideError();
        self.input.focus();
        self.sessionToken = null;

        self.dispatchEvent(new CustomEvent('address-clear', { bubbles: true }));
      });

      this.input.addEventListener('keydown', function onKeydown(e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          self.moveFocus(1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          self.moveFocus(-1);
        } else if (e.key === 'Enter') {
          const active = self.dropdown.querySelector('[aria-selected="true"]');
          if (active) {
            e.preventDefault();
            active.dispatchEvent(new MouseEvent('mousedown'));
          }
        } else if (e.key === 'Escape') {
          self.closeDropdown();
        }
      });

      this.input.addEventListener('blur', function onBlur() {
        setTimeout(function checkFocus() {
          if (!self.contains(document.activeElement)) {
            self.closeDropdown();
          }
        }, 150);
      });
    }

    async fetchSuggestions(query) {
      if (query.length < 4) {
        this.closeDropdown();
        return;
      }

      if (!this.sessionToken) {
        this.sessionToken = crypto.randomUUID();
      }

      try {
        const response = await fetch('https://places.googleapis.com/v1/places:autocomplete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': this.apiKey,
            'X-Goog-FieldMask': 'suggestions.placePrediction.placeId,suggestions.placePrediction.text',
          },
          body: JSON.stringify({
            input: query,
            includedRegionCodes: [this.country],
            languageCode: this.language,
            sessionToken: this.sessionToken,
          }),
        });

        if (!response.ok) {
          throw new Error('API error');
        }

        const data = await response.json();
        this.renderDropdown(data.suggestions || []);
      } catch {
        this.dispatchEvent(new CustomEvent('autocomplete-error', { bubbles: true }));
      }
    }

    renderDropdown(suggestions) {
      if (!suggestions.length) {
        this.closeDropdown();
        return;
      }

      const self = this;
      this.dropdown.innerHTML = '';

      suggestions.forEach(function renderItem(suggestion) {
        const prediction = suggestion.placePrediction;
        const li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.className = 'address-autocomplete__option';
        li.textContent = prediction.text.text;
        li.dataset.placeId = prediction.placeId;

        li.addEventListener('mousedown', function onSelect(e) {
          e.preventDefault();
          self.selectPlace(prediction.placeId, prediction.text.text);
        });

        self.dropdown.appendChild(li);
      });

      this.dropdown.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.positionDropdown();
    }

    positionDropdown() {
      // Always open the dropdown downwards, regardless of available space.
      this.dropdown.classList.remove('address-autocomplete__dropdown--above');
    }

    async selectPlace(placeId, displayText) {
      this.input.value = displayText;
      this.updateClearBtn();
      this.closeDropdown();

      try {
        const response = await fetch(
          `https://places.googleapis.com/v1/places/${placeId}?languageCode=${this.language}&sessionToken=${this.sessionToken}`,
          {
            headers: {
              'X-Goog-Api-Key': this.apiKey,
              'X-Goog-FieldMask': 'formattedAddress,addressComponents,location',
            },
          }
        );

        if (!response.ok) {
          throw new Error('API error');
        }

        const place = await response.json();

        this.sessionToken = null;

        this.hideError();
        this.dispatchEvent(
          new CustomEvent('address-selected', {
            bubbles: true,
            detail: {
              formattedAddress: place.formattedAddress,
              addressComponents: place.addressComponents,
              geometry: place.location,
            },
          })
        );
      } catch {
        this.dispatchEvent(new CustomEvent('autocomplete-error', { bubbles: true }));
      }
    }

    moveFocus(direction) {
      const items = Array.from(this.dropdown.querySelectorAll('li'));
      if (!items.length) {
        return;
      }

      const currentIndex = items.findIndex(function isSelected(item) {
        return item.getAttribute('aria-selected') === 'true';
      });

      items.forEach(function clearSelected(item) {
        item.removeAttribute('aria-selected');
      });

      let nextIndex = currentIndex + direction;
      if (nextIndex < 0) {
        nextIndex = items.length - 1;
      }
      if (nextIndex >= items.length) {
        nextIndex = 0;
      }

      items[nextIndex].setAttribute('aria-selected', 'true');
      items[nextIndex].scrollIntoView({ block: 'nearest' });
    }

    closeDropdown() {
      this.dropdown.hidden = true;
      this.dropdown.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
    }

    showError() {
      this.error.hidden = false;
      this.input.setAttribute('aria-invalid', 'true');
    }

    hideError() {
      this.error.hidden = true;
      this.input.removeAttribute('aria-invalid');
    }
  }

  if (typeof customElements.get('address-autocomplete') === 'undefined') {
    customElements.define('address-autocomplete', AddressAutocomplete);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["date-picker"] && !Shopify.designMode) return;
  try {
    class DatePicker extends HTMLElement {
    connectedCallback() {
      this.inputName = this.dataset.inputName || 'date';
      this.timeName = this.dataset.timeName || 'time';
      this.format = this.dataset.format || 'DD/MM/YYYY';
      this.minDate = this.dataset.minDate || '';
      this.slots = this.parseSlots();
      // Cache before render() replaces innerHTML and destroys the script elements.
      this._i18n = this.parseI18n();

      this.render();
      this.loadPikaday();
    }

    disconnectedCallback() {
      if (this.picker) {
        this.picker.destroy();
      }
    }

    parseSlots() {
      const script = this.querySelector('script[data-slots]');
      if (!script) {
        return {};
      }
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return {};
      }
    }

    parseI18n() {
      if (this._i18n) {
        return this._i18n;
      }
      const script = this.querySelector('script[data-i18n]');
      if (!script) {
        return null;
      }
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    render() {
      const i18n = this.parseI18n();
      const pickDay = i18n?.pickDay || '';
      const pickTime = i18n?.pickTime || '';

      this.innerHTML = `
        <input type="hidden" name="${this.inputName}">
        ${pickDay ? `<p class="date-picker__section-title">${pickDay}</p>` : ''}
        <div class="date-picker__calendar"></div>
        ${
          pickTime
            ? `<p class="date-picker__section-title date-picker__section-title--time" hidden>${pickTime}</p>`
            : ''
        }
        <div class="date-picker__times"></div>
      `;

      this.dateInput = this.querySelector('input[type="hidden"]');
      this.calendarEl = this.querySelector('.date-picker__calendar');
      this.timesEl = this.querySelector('.date-picker__times');
      this.timeTitleEl = this.querySelector('.date-picker__section-title--time');
    }

    loadPikaday() {
      if (window.Pikaday) {
        this.initPikaday();
        return;
      }

      if (document.querySelector('script[data-pikaday]')) {
        window.addEventListener('pikaday-loaded', this.boundInit(), { once: true });
        return;
      }

      if (!document.querySelector('link[data-pikaday-css]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/pikaday/css/pikaday.css';
        link.dataset.pikadayCss = 'true';
        document.head.appendChild(link);
      }

      window.addEventListener('pikaday-loaded', this.boundInit(), { once: true });

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/pikaday/pikaday.js';
      script.dataset.pikaday = 'true';
      script.async = true;
      script.onload = function onPikadayScriptLoaded() {
        window.dispatchEvent(new Event('pikaday-loaded'));
      };
      document.head.appendChild(script);
    }

    boundInit() {
      const self = this;
      return function onPikadayReady() {
        self.initPikaday();
      };
    }

    initPikaday() {
      const self = this;
      const i18n = this.parseI18n();

      const options = {
        field: this.dateInput,
        bound: false,
        container: this.calendarEl,
        firstDay: 1,
        i18n: {
          previousMonth: i18n?.previousMonth || 'Previous month',
          nextMonth: i18n?.nextMonth || 'Next month',
          months: i18n?.months || [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
          weekdays: i18n?.weekdays || ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          weekdaysShort: i18n?.weekdaysShort || ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        },
        disableDayFn: function isDateUnavailable(date) {
          const key = self.dateKey(date);
          const daySlots = self.slots[key];
          return !daySlots || daySlots.length === 0;
        },
        toString: function formatPickerDate(date) {
          return self.formatDate(date);
        },
        parse: function parsePickerDate(str) {
          return self.parseDate(str);
        },
        onSelect: function onDateSelected(date) {
          self.renderTimes(date);
          self.dispatchEvent(
            new CustomEvent('date-selected', {
              bubbles: true,
              detail: {
                date: date,
                formatted: self.dateInput.value,
              },
            })
          );
        },
      };

      if (this.minDate === 'today') {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        options.minDate = today;
      } else if (this.minDate) {
        options.minDate = new Date(this.minDate);
      }

      this.picker = new Pikaday(options);
    }

    findFirstAvailableDate() {
      const start = new Date();
      start.setHours(0, 0, 0, 0);

      if (this.minDate && this.minDate !== 'today') {
        const minD = new Date(this.minDate);
        if (minD > start) {
          start.setTime(minD.getTime());
        }
      }

      const available = Object.keys(this.slots)
        .filter(function hasSlots(key) {
          return this.slots[key].length > 0;
        }, this)
        .map(function toDate(key) {
          return new Date(key);
        })
        .filter(function afterStart(date) {
          return date >= start;
        })
        .sort(function asc(a, b) {
          return a - b;
        });

      return available[0] || null;
    }

    dateKey(date) {
      const yyyy = date.getFullYear();
      const mm = (date.getMonth() + 1).toString().padStart(2, '0');
      const dd = date.getDate().toString().padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }

    renderTimes(date) {
      const key = this.dateKey(date);
      const daySlots = this.slots[key] || [];

      if (daySlots.length === 0) {
        this.timesEl.innerHTML = '';
        if (this.timeTitleEl) {
          this.timeTitleEl.hidden = true;
        }
        return;
      }

      if (this.timeTitleEl) {
        this.timeTitleEl.hidden = false;
      }

      const timeName = this.timeName;
      const self = this;

      this.timesEl.innerHTML = daySlots
        .map(function buildTimeOption(slot, i) {
          const id = `dp-time-${i}`;
          return `
            <label class="date-picker__time-option" for="${id}">
              <input
                type="radio"
                id="${id}"
                name="${timeName}"
                value="${slot}"
                required
              >
              <span class="date-picker__time-label">${slot}</span>
            </label>
          `;
        })
        .join('');

      this.timesEl.querySelectorAll('input[type="radio"]').forEach(function attachTimeListener(radio) {
        radio.addEventListener('change', function onTimeChanged() {
          self.dispatchEvent(
            new CustomEvent('time-selected', {
              bubbles: true,
              detail: { time: radio.value },
            })
          );
        });
      });
    }

    setSlots(slots) {
      this.slots = slots;
      this.dateInput.value = '';
      this.timesEl.innerHTML = '';
      if (this.timeTitleEl) {
        this.timeTitleEl.hidden = true;
      }
      if (!this.picker) {
        return;
      }
      this.picker.setDate(null, true);
      const firstAvailableDate = this.findFirstAvailableDate();
      if (firstAvailableDate) {
        this.picker.gotoDate(firstAvailableDate);
      }
      this.picker.draw();
    }

    formatDate(date) {
      const dd = date.getDate().toString().padStart(2, '0');
      const mm = (date.getMonth() + 1).toString().padStart(2, '0');
      const yyyy = date.getFullYear().toString();
      const yy = yyyy.slice(-2);

      return this.format.replace('DD', dd).replace('MM', mm).replace('YYYY', yyyy).replace('YY', yy);
    }

    parseDate(str) {
      const fmt = this.format;
      const ddIdx = fmt.indexOf('DD');
      const mmIdx = fmt.indexOf('MM');
      const yyyyIdx = fmt.indexOf('YYYY');
      const yyIdx = fmt.indexOf('YY');

      const d = ddIdx >= 0 ? parseInt(str.slice(ddIdx, ddIdx + 2), 10) : 1;
      const m = mmIdx >= 0 ? parseInt(str.slice(mmIdx, mmIdx + 2), 10) - 1 : 0;

      let y;
      if (yyyyIdx >= 0) {
        y = parseInt(str.slice(yyyyIdx, yyyyIdx + 4), 10);
      } else if (yyIdx >= 0) {
        y = 2000 + parseInt(str.slice(yyIdx, yyIdx + 2), 10);
      } else {
        y = new Date().getFullYear();
      }

      return new Date(y, m, d);
    }
  }

  if (typeof customElements.get('date-picker') === 'undefined') {
    customElements.define('date-picker', DatePicker);
  }
  } catch(e) { console.error(e); }
})();

})();
